
const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const ListNotify = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'NOTIFY_LIST_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'NOTIFY_LIST_ERROR':
            return { loading: false, error: true, data: [] };
        case 'NOTIFY_LIST_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'NOTIFY_LIST_RESET':
            return { loading: false, error: false, data: [] };
        default:
            return state;
    }
}

export default ListNotify